import axios from "axios"

export const ObtenerListaReembolso = async () => {
    return axios.get('api/Home/ObtenerListaReembolso')
}

export const filtrarListaReembolso = async (data:any) => {
    return axios.post('api/Home/FiltrarListaReembolso', data)
}

export const homeSetUsuario = async (usuarioComercio:{}) => {
    return axios.post('api/Home/SetUsuario', usuarioComercio)
}

export const ConsultarTransacciones = async (presentacion: number, producto: number) => {
    return axios.get(`api/Home/ConsultarTransacciones?presentacion=${presentacion}&producto=${producto}`)
}
